import {Permission, userHasAllPermissions, userHasAnyPermission, userHasPermission} from "./permissions";
import {getProductData, isKITProduct, type ProductData} from "../models/ProductData";
import {isProductPMA} from "../feature/ProductDescriptor/v1/productDescriptorUtils";
import {userIsCustomer, userIsLoggedIn} from "./roles";
import {hasSuccessor} from "~/utils/productUtils";
import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

interface CanSeeListPriceProps {
  product: ProductDescriptor;
  hasSurcharge?: boolean;
  isSpecialPrice?: boolean;
}

export const canSeeListPrice = ({ product, isSpecialPrice, hasSurcharge }: CanSeeListPriceProps) => {
  return (
    userHasPermission(Permission.SEE_LIST_PRICE) &&
    product.base.quantityVisible &&
    !isKITProduct(product.base) &&
    !isProductPMA(product) &&
    !isSpecialPrice &&
    !hasSurcharge
  );
};

export const canSeeWishlistButton = () => {
  return !userIsLoggedIn() || userHasPermission(Permission.ADD_TO_WISHLIST);
};

export const canSeeAddToCartButton = (strict = false) => {
  if (userIsCustomer()) {
    return (
      userHasAllPermissions(Permission.PRICE, Permission.AVAILABILITY) &&
      (strict
        ? userHasPermission(Permission.ADD_TO_CART)
        : userHasAnyPermission(Permission.ADD_TO_CART, Permission.ADD_TO_QUOTE))
    );
  } else if (userHasPermission(Permission.ADD_TO_CART)) {
    return true;
  }
};

export const canSeeNewProductVersion = (product: ProductData | ProductDescriptor) => {
  return userIsLoggedIn() && hasSuccessor(getProductData(product));
};

export const isMarketingConsentEnabled = () => window.SCHA.toggles.marketingConsentEnabled;

export const isLineLevelCustomerOrderNumberEnabled = () => window.SCHA.toggles.customerOrderNumberAtLineLevel;

export const isTruncateDesignationsEnabled = () => true;

export const isInvoiceNumberEnabled = () => window.SCHA.config.downloadInvoice;

export const isCADInquiryEnabled = () => false;

export const isMultiAccountOrderSearchEnabled = () => window.SCHA.toggles.multipleAccountSearchEnabled;

export const isPartialDeliveriesEnabled = () => true;

/**
 * When enabled, surcharge is already included in price coming from SAP (old way).
 * When disabled, surcharge will be added by the FE (new way).
 */
export const isSurchargeIncludedInPriceValue = () => false;

export const isNewNavigationEnabled = () => window.SCHA.feature.showNewNavigation ?? false;
